export const PRDCATLOGOFILETYPES = ["image/png","image/jpg","image/jpeg","image/gif"];